import { RootState } from 'redux/reducers/rootReducer';

const contractorCompanyCreatedAtSelector = (state: RootState) =>
  state.contractorCompany.contractorCompanyCreatedAt;

export { contractorCompanyCreatedAtSelector };
